export class ExpenseQuickEntryCategoryModel {
    public CategoryID: number;
    public CategoryName: string;

    constructor(
        id: number,
        name: string
    ) {
        this.CategoryID = id;
        this.CategoryName = name;
    }

    static getCategories(): ExpenseQuickEntryCategoryModel[] {
        return [
            new ExpenseQuickEntryCategoryModel(1, 'Food'),
            new ExpenseQuickEntryCategoryModel(2, 'Credit Card'),
            new ExpenseQuickEntryCategoryModel(3, 'Expense'),
            new ExpenseQuickEntryCategoryModel(4, 'Shopping'),
            new ExpenseQuickEntryCategoryModel(5, 'Bills'),
            new ExpenseQuickEntryCategoryModel(6, 'Travel'),
            new ExpenseQuickEntryCategoryModel(7, 'Medical'),
            new ExpenseQuickEntryCategoryModel(8, 'Utility'),
            new ExpenseQuickEntryCategoryModel(9, 'Other')
        ];
    }
}